import { createUseI18n } from "keycloakify/login";

export const { useI18n } = createUseI18n({
    /* spell-checker: disable */
    // NOTE: Here you can override the default i18n messages
    // or define new ones that, for example, you would have
    // defined in the Keycloak admin UI for UserProfile
    // https://user-images.githubusercontent.com/6702424/182050652-522b6fe6-8ee5-49df-aca3-dba2d33f24a5.png
    da: {
        doLogout: "Log ud",
        // Col 2: request login
        partnerWithoutLogin: "Infinigate forhandler uden webshop login?",
        requestLogin: "Venligst benyt webshopformularen for at få oprettet en konto",
        requestLoginBtn: "Anmod om webshop login",
        // Col 3: become partner
        notYetPartner: "Endnu ikke Infinigate forhandler?",
        pleaseRegister: "Venligst registrer dig via forhandleransøgningen.",
        partnerRequestBtn: "Bliv forhandler",
        headline: "Personlig og digital forbindelse",
        subHeadline: "Din indgang til vækst. Få adgang til information, træning, værktøjer og ressourcer når som helst og hvor som helst for at øge din rentabilitet."
    },
    de: {
        doLogout: "Abmelden",
        // Col 2: request login
        partnerWithoutLogin: "Infinigate Partner ohne Login?",
        requestLogin: "Bitte fordern Sie mit Hilfe des Login-Formulars einen Account an.",
        requestLoginBtn: "Login anfordern",
        // Col 3: become partner
        notYetPartner: "Noch kein Infinigate Partner?",
        pleaseRegister: "Bitte registrieren Sie sich mit Hilfe des Partner-Formulars.",
        partnerRequestBtn: "Partner werden",
        headline: "Persönlich und digital vernetzt",
        subHeadline: "Ihr Tor zum Wachstum. Greifen Sie jederzeit und überall auf Informationen, Schulungen, Tools und Ressourcen zu - und steigern Sie Ihre Rentabilität."
    },
    en: {
        doLogout: "Logout",
        // Col 2: request login
        partnerWithoutLogin: "Partner World and eShop registration",
        requestLogin: "Please request an account using the login form.",
        requestLoginBtn: "Request login",
        // Col 3: become partner
        notYetPartner: "Become an Infinigate Partner",
        pleaseRegister: "Please register using the partner form.",
        partnerRequestBtn: "Become a partner",
        headline: "Connecting Personally & Digitally",
        subHeadline: "Your gateway to growth. Access information, training, tools and resources anytime, anywhere to boost your profitability. "
    },
    fi: {
        doLogout: "Kirjaudu ulos",
        // Col 2: request login
        partnerWithoutLogin: "Infinigate-kumppanit ilman verkkokauppatunnuksia?",
        requestLogin: "Rekisteröidy saadaksesi webshop-tunnukset.",
        requestLoginBtn: "Hae webshop-tunnuksia",
        // Col 3: become partner
        notYetPartner: "Tule Infinigate-jälleenmyyjäksi?",
        pleaseRegister: "Hae jälleenmyyjäksi täyttämällä partner-lomake.",
        partnerRequestBtn: "Hae jälleenmyyjäksi",
        headline: "Henkilökohtaisia ja digitaalisia yhteyksiä",
        subHeadline: "Kasvun portti. Hyödynnä tietoa,   koulutuksia, työkaluja ja muita resursseja missä ja milloin tahansa   liiketoimintasi tuottavuuden lisäämiseen."
    },
    fr: {
        doLogout: "Déconnexion",
        // Col 2: request login
        partnerWithoutLogin: "Inscription au Partner World et à l'eShop",
        requestLogin: "Veuillez demander un compte en utilisant le formulaire de connexion.",
        requestLoginBtn: "Demande de connexion",
        // Col 3: become partner
        notYetPartner: "Devenir un partenaire Infinigate",
        pleaseRegister: "Veuillez vous inscrire en utilisant le formulaire de partenariat.",
        partnerRequestBtn: "Devenir partenaire",
        headline: "Connexion personnelle et numérique",
        subHeadline: "Votre passerelle vers la croissance. Accédez à tout moment et en tout lieu à des informations, formations, outils et ressources pour doper votre rentabilité."
    },
    no: {
        doLogout: "Logg ut",
        // Col 2: request login
        partnerWithoutLogin: "Er du en Infinigate-partner, men mangler tilgang til vår nettbutikk?",
        requestLogin: "Vennligst fyll ut skjemaet for tilgang til nettbutikken, og vi vil hjelpe deg med tilgangen så snart som mulig.",
        requestLoginBtn: "Be om tilgang til nettbutikken",
        // Col 3: become partner
        notYetPartner: "Er du ennå ikke en Infinigate-partner, men ønsker å bli det?",
        pleaseRegister: "Vennligst registrer deg ved å fylle ut vårt partnerregistreringsskjema, og vi vil hjelpe deg så snart som mulig.",
        partnerRequestBtn: "Bli partner",
        headline: "Personlig og digital tilkobling",
        subHeadline: "Din portal til vekst. Få tilgang til informasjon, opplæring, verktøy og ressurser, når som helst og hvor som helst – slik at du kan øke lønnsomheten."
    },
    nl: {
        doLogout: "Uitloggen",
        // Col 2: request login
        partnerWithoutLogin: "Partner Portaal en eShop registratie",
        requestLogin: "Dien alstublieft een aanvraag in voor een account via het registratieformulier.",
        requestLoginBtn: "Infinigate Partnerportaal",
        // Col 3: become partner
        notYetPartner: "Word een Infinigate Partner",
        pleaseRegister: "Meld u alstublieft aan via ons partnerformulier.",
        partnerRequestBtn: "Word Partner",
        headline: "Verbinden, persoonlijk en digitaal",
        subHeadline: "Uw toegangspoort tot groei. Krijg altijd en overal toegang tot informatie, opleiding, tools en resources om uw winstgevendheid te verhogen."
    },
    sv: {
        doLogout: "Logga ut",
        // Col 2: request login
        partnerWithoutLogin: "Infinigate-partner utan åtkomst till webbshopen?",
        requestLogin: "Ansök om inloggningsuppgifter till Infinigates webbshop.",
        requestLoginBtn: "Skapa konto",
        // Col 3: become partner
        notYetPartner: "Är du inte redan en Infinigate-partner?",
        pleaseRegister: "Ingen fara! Ansök om att bli en partner genom att dela några detaljer om dig och ditt företag.",
        partnerRequestBtn: "Bli kund",
        headline: "Anslut personligen och digitalt",
        subHeadline: "Din väg till tillväxt. Åtkomst till information, utbildning, verktyg och resurser när som helst och var som helst för att öka din lönsamhet."
    }
    /* spell-checker: enable */
});

export type I18n = NonNullable<ReturnType<typeof useI18n>>;
